import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPencil = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 33,
	viewBox: "0 0 32 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_6922_92)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M4 23.5V28.5H9L23.7467 13.7534L18.7467 8.75337L4 23.5ZM28.5467 8.95337L23.5467 3.95337L20.1733 7.34004L25.1733 12.34L28.5467 8.95337Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6922_92",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white",
			transform: "translate(0 0.5)"
		})
	}) })]
});
export default SvgPencil;
